import React, { createContext, useContext, useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import HomePage from "@/pages/HomePage";
import UniversityPage from "@/pages/UniversityPage";
import BranchPage from "@/pages/BranchPage";
import SubjectPage from "@/pages/SubjectPage";
import ResourcesPage from "@/pages/ResourcesPage";
import NotesViewerPage from "@/pages/NotesViewerPage";
import CGPACalculatorPage from "@/pages/CGPACalculatorPage";
import AdminPage from "@/pages/AdminPage";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => setUser(res.data))
        .catch(() => {
          localStorage.removeItem("token");
          setToken(null);
          setUser(null);
        });
    }
  }, [token]);

  useEffect(() => {
    axios.post(`${API}/seed`).catch(() => {});
  }, []);

  const login = (tkn, usr) => {
    localStorage.setItem("token", tkn);
    setToken(tkn);
    setUser(usr);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      <div className="min-h-screen bg-[#0f0f0f] noise-overlay">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/university/:uniId" element={<UniversityPage />} />
              <Route path="/university/:uniId/branch/:branchCode" element={<BranchPage />} />
              <Route path="/subject/:subjectId" element={<SubjectPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/notes/view" element={<NotesViewerPage />} />
              <Route path="/cgpa-calculator" element={<CGPACalculatorPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster theme="dark" />
      </div>
    </AuthContext.Provider>
  );
}

export default App;
